import Vue from "vue";
import VueRouter from "vue-router";
import MyTeamIndex from "../MyTeamIndex";
import OtherTeamIndex from "../OtherTeamIndex";
import Login from "../components/Pages/Login";
import Top from "../components/Pages/Top";
import Check from "../components/Pages/Check";
import Point from "../components/Pages/Point";
import OtherTeam from "../components/Pages/OtherTeam";
import AddItem from "../components/Pages/AddItem";
import AddItemResult from "../components/Pages/AddItemResult";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index.html",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    component: MyTeamIndex,
    children: [
      {
        path: "/top",
        name: "Top",
        component: Top,
        props: true
      },
      {
        path: "/check",
        name: "Check",
        component: Check
      },
      {
        path: "/point",
        name: "Point",
        component: Point
      },
      {
        path: "/otherTeam",
        name: "OtherTeam",
        component: OtherTeam
      },
      {
        path: "/addItem",
        name: "AddItem",
        component: AddItem
      },
      {
        path: "/addItemResult",
        name: "AddItemResult",
        component: AddItemResult
      }
    ]
  },
  {
    path: "/other",
    component: OtherTeamIndex,
    children: [
      {
        path: "/other/top",
        name: "OtherTeamTop",
        component: Top,
        props: true
      },
      {
        path: "/other/check",
        name: "OtherTeamCheck",
        component: Check
      },
      {
        path: "/other/point",
        name: "OtherTeamPoint",
        component: Point
      },
      {
        path: "/other/otherTeam",
        name: "OtherTeam",
        component: OtherTeam
      }
    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
